<template>
    <div class="dropdown" ref="dropdown">
        <div v-if="isLoading" class="d-flex justify-content-center spinner-border text-primary spinner-position form"></div>
        <div v-if="isLoading" class="spinner"></div>
        <a href="#" 
           @click="!isLoading && toggleDropdown()" 
           role="button" 
           id="dropdownMenuLink" 
           data-bs-toggle="dropdown" 
           aria-expanded="false"
           :class="{ 'disabled': isLoading }">
            <img :src="(!imageErrorStatus && image_url) ? image_url : defaultAvatar" alt="User Avatar" @error="imageError" class="avatar" />
        </a>
        <div>
            <ul class="dropdown-menu custom-position custom-shadow" :class="{ 'd-block': isActive && !isLoading }" aria-labelledby="dropdownMenuLink">
                <div class="profile-attribute mobile-profile">
                    <div class="user-name font-color">{{ fullName }}</div>
                    <div class="span-name">
                    <span>
                        <span v-if="userProfile">
                            <span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="black"
                                class="bi bi-person-fill"
                                viewBox="0 0 24 16"
                            >
                                <path
                                d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                                />
                            </svg>
                            </span>
                            <span>{{ userProfile }}</span>
                        </span>
                        <div>
                        <span>{{ user.email }}</span>
                        <div class="tier-icon" :class="{ 'tier-centered': !isPointSystemActive }" v-if="isMember">
                            <i class="fas fa-medal fa-2x"></i>
                            <span>{{ displayTier }}</span>
                        </div>
                        <div class="stats-container" v-if="isMember && isPointSystemActive" >
                            <div class="stats-item">
                                <div class="stats-icon-label">
                                    <div class="stats-label">Points</div>
                                </div>
                                <div class="stats-value">{{ displayPoints }}</div>
                            </div>
                            <div class="stats-divider"></div>
                            <div class="stats-item">
                                <div class="stats-icon-label">
                                    <div class="stats-label">Vouchers</div>
                                </div>
                                <div class="stats-value">{{ displayOwnedVouchers }}</div>
                            </div>
                        </div>
                        </div>
                        <o-button
                            :variant="'custom-switch-mobile'"
                            v-if="menuvisibility?.includes('Switch')"
                            @click="showModalSwitch"
                            :disabled="isLoading"
                            ><svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                fill="currentColor"
                                class="bi bi-toggle-on"
                                viewBox="0 0 24 16"
                            >
                                <path
                                d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10H5zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
                                />
                                </svg>switch
                            </o-button>
                    </span>
                    </div>
                </div>
                <div v-if="isMember" class="legal-contact-wrapper">
                    <a class="legal-item" @click="showPrivacyPolicy">
                        Privacy Policy & Terms
                    </a>
                    <div class="legal-divider"></div>
                    <a class="legal-item" @click="showContactInfo">
                        Contact Info
                    </a>
                </div>
                <div class="custom-user-info-mobile">
                    <div class="after-profile-sett d-flex">
                        <router-link :to="isMember ? '/client/benefit' : '/account'" class="a-profile-custom hover-feedback" @click="closeDropdown">
                            <div class="profile-div-inner text-center span-custom user-info-mobile">
                                My Profile
                            </div>
                        </router-link>
                        <a href="#" @click.prevent="logout" class="a-profile-custom hover-feedback" :class="{ 'disabled': isLoading }">
                            <div class="profile-div-inner text-center span-custom user-info-mobile">
                                {{ isLogoutLoading ? 'Logging out...' : 'Log Out' }}
                            </div>
                        </a>
                    </div>
                </div>
            </ul>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import { OButton } from '@/components/OmnihControl';
import { usePointSystem } from '@/composables/pointsystem';
import { setSwipeBackEnabled } from '@/services/swipeBack';
import { eventBus } from '@/eventBus';

export default {
    props: {
        menuvisibility: Array,
    },
    components: {
        OButton,
    },
    data: function () {
        return {
            userProfile: '',
            image_url: '',
            imageErrorStatus: false,
            isLoading: false,       
            isLogoutLoading: false, 
            isAvatarLoading: false, 
            isMemberInfoLoading: false,
            isActive: false,
            memberInfo: {
                ownedVouchers: '',
                tier: '',
                points: '',
            },
            loadingRequests: 0,
        };
    },
    watch: {
        selectedBusinessProfile(newVal) {
            if (newVal.corporate_id !== null) {
                this.userProfile = this.businessProfiles.corporate.find((corp) => corp.id == newVal.corporate_id).name;
            }
            if (newVal.branch_id !== null) {
                const corporate = this.businessProfiles.corporate.length > 1 ? this.businessProfiles.corporate.find((corp) => corp.id == newVal.corporate_id) : this.businessProfiles.corporate.at(0);
                this.userProfile = corporate.branch.find((branch) => branch.id == newVal.branch_id).name;
            }
            if (newVal.merchant_id !== null) {
                const corporate = this.businessProfiles.corporate.length > 1 ? this.businessProfiles.corporate.find((corp) => corp.id == newVal.corporate_id) : this.businessProfiles.corporate.at(0);
                const branch = corporate.branch.length > 1 ? corporate.branch.find((branch) => branch.id == newVal.branch_id) : corporate.branch.at(0);
                this.userProfile = branch.merchant.find((merchant) => merchant.id == newVal.merchant_id).name;
            }
        },
        isAvatarLoading(val) {
            this.updateLoadingState('avatar', val);
        },
        isMemberInfoLoading(val) {
            this.updateLoadingState('memberInfo', val);
        },
        isLogoutLoading(val) {
            this.updateLoadingState('logout', val);
        },
        '$store.state.Auth.userInfo.member.member_avatar': function(newVal) {
            if (newVal) {
                this.image_url = newVal;
                this.imageErrorStatus = false;
            }
        }
    },
    mounted() {
        this.initializeComponent();
        document.addEventListener('click', this.handleClickOutside);
        eventBus.on('network-reconnected', this.initializeComponent);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
        eventBus.off('network-reconnected', this.initializeComponent);
    },
    methods: {
        updateLoadingState(requestType, isLoading) {
            if (isLoading) {
                this.loadingRequests++;
            } 
            else if (this.loadingRequests > 0) {
                this.loadingRequests--;
            }
            
            this.isLoading = this.loadingRequests > 0;
        },
        
        async initializeComponent() {
            this.isLoading = true;
            
            const promises = [this.fetchAvatar()];
            
            if (this.isMember) {
                promises.push(this.fetchMemberInfo());
            }
            
            await Promise.all(promises);
            this.isLoading = false;
        },
        
        imageError(event) {
            if (event) {
                this.imageErrorStatus = true;
            }
        },
        
        async fetchAvatar() {
            this.isAvatarLoading = true;
            this.imageErrorStatus = false;
            this.image_url = '';
            try {
                const memberAvatarFromStore = this.$store.state.Auth.userInfo?.member?.member_avatar;
                if (memberAvatarFromStore) {
                    this.image_url = memberAvatarFromStore;
                    return;
                }

                const userId = localStorage.getItem('id') || this.$store.state.Auth.userInfo?.id || this.$store.state.Auth.currUser?.id;
                if (userId) {
                    const resp = await this.$store.dispatch('User/getAvatar', userId);
                    this.image_url = resp.data.data;
                } else {
                    console.error('User ID is undefined');
                }
            } catch (error) {
                console.error('Error fetching avatar:', error);
            } finally {
                this.isAvatarLoading = false;
            }
        },
        
        async fetchMemberInfo() {
            this.isMemberInfoLoading = true;
            try {
                const resp = await this.$store.dispatch('ClientBenefit/read');
                const data = resp.data.data;
                this.memberInfo.tier = data.tier_name || '';
                this.memberInfo.ownedVouchers = data.owned_vouchers;
                this.memberInfo.points = data.points;
            } catch (error) {
                console.error('Error fetching member info:', error);
            } finally {
                this.isMemberInfoLoading = false;
            }
        },
        
        showModalSwitch() {
            if (!this.isLoading) {
                this.$emit("showModalSwitch");
                this.closeDropdown();
            }
        },
        
        async logout() {
            if (this.isLogoutLoading || this.isLoading) {
                return;
            }
            
            this.isLogoutLoading = true;
            this.closeDropdown();
            
            try {
                const isMemberUser = this.isMember;
                const newAuthFlag = this.$store.getters['FeatureFlag/getNewAuthModuleFlag'];

                const message = {
                    type: 'logout',
                    data: 'logoutSucceded',
                    res: null,
                    token: null,
                    email: null,
                };
                await this.$store.dispatch('Auth/logout');
                
                // Disable swipe-back immediately — prevent flash of authenticated page during transition
                await setSwipeBackEnabled(false);

                if (newAuthFlag === 'ACTIVE') {
                    if (isMemberUser) {
                        this.$router.replace('/member/login');
                    } else {
                        this.$router.replace('/backoffice/login');
                    }
                } else {
                    this.$router.replace({ name: "Login" });
                }

                window.parent.postMessage(message, '*');
            } catch (err) {
                console.error('Logout error:', err);
            } finally {
                this.isLogoutLoading = false;
            }
        },
        
        toggleDropdown() {
            if (!this.isLoading) {
                this.isActive = !this.isActive;
            }
        },
        
        handleClickOutside(event) {
            if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                this.closeDropdown();
            }
        },
        
        closeDropdown() {
            this.isActive = false;
        },
        showPrivacyPolicy: async function() {
            this.$emit('showPrivacyPolicy');
        },
        showContactInfo: async function() {
            this.$emit('openContactInfo');
        },
    },
    computed: {
        ...mapState({
            businessProfiles: state => state.Auth.businessProfiles,
            selectedBusinessProfile: state => state.Auth.selectedBusinessProfile,
            dashboards: state => state.Dashboard.dashboards,
            user: state => state.Auth.currUser,
        }),
        defaultAvatar() {
            const title = this.user?.title || this.$store.state.Auth.userInfo?.title || '';
            return title === 'Mr.'
                ? 'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/man.png'
                : 'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/woman.png';
        },
        fullName() {
            const title = this.user.title || '';
            const firstName = this.user.first_name || '';
            const lastName = this.user.last_name || '';
            return `${title} ${firstName} ${lastName}`.trim() || this.user.name || this.user.email || '';
        },
        getInitials() {
            const title = this.user.title || '';
            const firstName = this.user.first_name || '';
            const lastName = this.user.last_name || '';
            const name = `${title} ${firstName} ${lastName}`.trim() || this.user.name || this.user.email || '';
            if (!name) return '?';
            const words = name.split(' ').filter(Boolean);
            if (words.length >= 2) {
                return (words[0][0] + words[1][0]).toUpperCase();
            }
            return name.substring(0, 2).toUpperCase();
        },
        isMember() {
            // Fix untuk native: fallback ke localStorage jika user.level belum ter-load
            if (this.user && this.user.level) {
                return this.user.level === 'member';
            }
            // Fallback untuk native platform saat data belum ter-load dari store
            const level = localStorage.getItem('level');
            return level === 'member';
        },
        policiesLoading() {
            return this.$store.getters['Policies/isLoading'];
        },
        hasError() {
            return this.$store.getters['Policies/hasError'];
        },
        errorMessage() {
            return this.$store.getters['Policies/errorMessage'];
        },
        privacyPolicyHtml() {
            return this.$store.state.Policies.public_privacy_policy?.content || '';
        },
        termsConditionsHtml() {
            return this.$store.state.Policies.public_terms_conditions?.content || '';
        },
        isPointSystemActive() {
            const { isPointSystemActive } = usePointSystem();
            return isPointSystemActive.value;
        },
        displayPoints() {
            if (this.memberInfo.points !== '' && this.memberInfo.points !== null && this.memberInfo.points !== undefined) {
                return this.memberInfo.points;
            }
            return this.$store.state.ClientDashboard?.dashboard?.points ?? this.$store.state.Auth.userInfo?.member?.points ?? 0;
        },
        displayOwnedVouchers() {
            if (this.memberInfo.ownedVouchers !== '' && this.memberInfo.ownedVouchers !== null && this.memberInfo.ownedVouchers !== undefined) {
                return this.memberInfo.ownedVouchers;
            }
            return this.$store.state.ClientDashboard?.dashboard?.owned_vouchers ?? this.$store.state.Auth.userInfo?.member?.filtered_vouchers?.length ?? 0;
        },
        displayTier() {
            if (this.memberInfo.tier && this.memberInfo.tier !== '-') {
                return this.memberInfo.tier.length > 25 ? this.memberInfo.tier.substring(0, 25) : this.memberInfo.tier;
            }
            const tierName = this.$store.state.ClientDashboard?.dashboard?.tier?.name || this.$store.state.Auth.userInfo?.member?.tier_name || 'Member';
            return tierName.length > 25 ? tierName.substring(0, 25) : tierName;
        },
    },
};
</script>

<style>
.user-name.font-color{
    color: #4A4A4A;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.3;
    text-align: left;
    word-break: break-word;
    overflow-wrap: break-word;
    margin-bottom: 6px;
}
.custom-user-info-mobile .after-profile-sett {
    display: flex; /* Ensure items are aligned in a row */
    width: 100%; /* Make both buttons take equal width */
    position: relative;
    z-index: 2;
}

.a-profile-custom {
    flex: 1; /* Make each link take equal space */
    text-align: center; /* Center text inside the link */
    text-decoration: none;
}

.a-profile-custom.hover-feedback {
    border-radius: 8px;
    transition: background-color 0.2s ease, transform 0.1s ease;
    cursor: pointer;
}

.a-profile-custom.hover-feedback:hover {
    background-color: var(--secondary-color, rgba(249, 62, 62, 0.08));
}

.a-profile-custom.hover-feedback:active {
    background-color: var(--secondary-color, rgba(249, 62, 62, 0.15));
    transform: scale(0.98);
}

.profile-div-inner {
    padding: 10px 0; /* Add some padding for the text */
}
    .custom-position{
        position: fixed;
        right: 0px;
        top: 40px;
    }
    .mobile-profile span{
        color: #4A4A4A;
        font-size: 13px;
        word-break: break-word;
        overflow-wrap: break-word;
    }

    .profile-attribute.mobile-profile {
        position: relative;
        z-index: 2;
    }

    .user-name.user-info{
        font-size: 18px;
        color: #4A4A4A;
    }

    .span-custom.user-info-mobile{
        color: var(--primary-color, #f93e3e);
        margin-left: 0px;
        font-weight: 600;
        display: inline-block;
    }

    .after-profile.custom-user-info-mobile{
        padding: 10px 8px 0px 0px;
    }

    .dropdown-menu.custom-position.custom-shadow.d-block{
        border: none;
        border-radius: 10px;
        padding: 10px 25px;
        box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.05);
        width: 280px;
        overflow: hidden;
    }

    .custom-user-info-mobile.buttons-improved .after-profile-sett {
        gap: 12px;
        margin-top: 10px;
    }

    .custom-user-info-mobile.buttons-improved .a-profile-custom {
        background: white;
        border: 2px solid var(--primary-border, #f93e3e);
        border-radius: 8px;
        padding: 5px 0;
        transition: all 0.3s ease;
    }

    .custom-user-info-mobile.buttons-improved .a-profile-custom:first-child {
        background: var(--primary-color, #f93e3e);
    }

    .custom-user-info-mobile.buttons-improved .a-profile-custom:first-child .span-custom {
        color: white !important;
    }

    .custom-user-info-mobile.buttons-improved .a-profile-custom:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px var(--secondary-color, rgba(249, 62, 62, 0.2));
    }

    .custom-user-info-mobile.buttons-improved .profile-div-inner {
        font-size: 14px;
        font-weight: 600;
    }

    .btn.btn-custom-switch-mobile {
        padding: 0px;
        color:#000;
    }

    .btn.btn-custom-switch-mobile:focus {
        outline: none;
        border: none;
        box-shadow: none;
    }

    .btn-custom-switch-mobile:hover {
        color: #808080;
    }

    .avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        object-fit: cover;
    }

    .member-avatar-placeholder {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--primary-gradient, linear-gradient(135deg, #F93E3E 0%, #E02020 100%));
        color: #ffffff;
        font-size: 11px;
        font-weight: 600;
        user-select: none;
    }
</style>

<style scoped>
.profile-div-inner.text-center {
    display: inline-block;
    font-weight: 600;
}

.tier-icon{
    position: relative;
    width: 100%;
    left: 0;
    top: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    margin-bottom: 8px;
}

.tier-icon.tier-centered {
    position: relative;
    width: auto;
    left: auto;
    transform: none;
    top: auto;
    justify-content: center;
    margin-top: 12px;
    margin-bottom: 12px;
}

.tier-icon i {
    color: var(--primary-color, #f93e3e);
    position: relative;
    left: 0;
    margin-right: 10px;
}

.tier-icon.tier-centered i {
    position: relative;
    left: 0;
    margin-right: 10px;
}

.tier-icon span {
    font-size: 16px;
    font-weight: 700;
    color: var(--primary-color, #f93e3e);
    margin-left: 0;
    display: inline-block;
    width: auto;
    height: 24px;
    line-height: 24px;
    text-align: center;
    white-space: nowrap;
}

.tier-icon.tier-centered span {
    margin-left: 0;
    width: auto;
    padding: 0 10px;
}

.stats-container {
    background: var(--primary-color, #f93e3e);
    border-width: 2px 0px 2px 0px;
    border-style: dashed;
    border-color: white;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 12px 0;
    margin-top: 12px;
    width: calc(100% + 50px);
    position: relative;
    left: -25px;
}

.stats-divider {
    width: 1px;
    height: 60px;
    background: white;
    margin: 0 7px;
}

.stats-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 120px;
    height: 80px;
}
  
.stats-icon-label {
    display: flex;
    align-items: center; /* Vertically center the items */
}

.stats-icon {
    margin-right: 10px;
}

.stats-icon i {
    font-size: 25px; /* Adjust the font size as needed */
    color: #FFFFFF;
}

.stats-label {
    font-size: 20px;
    color: #FFFFFF;
    font-weight: 700;

}

.stats-value {
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
}


.legal-contact-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0px 0 0px;
    padding-top: 0px;
    border-top: 1px dashed #e0e0e0;
    position: relative;
    z-index: 2;
}

.legal-item {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex: 1;
    font-size: 11px;
    color: #888;
    cursor: pointer;
    text-decoration: none;
    padding: 0 5px;
    transition: color 0.2s;
    line-height: 1.2;
}

.legal-item:hover {
    color: var(--primary-color, #f93e3e);
}

.legal-divider {
    width: 1px;
    height: 20px;
    background-color: #ddd;
    margin: 0 5px;
}
</style>